import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { AuthLayout } from "../../layouts/AuthLayout";
import { ErrorModal } from "../../components/Error/ErrorModal";
import { Spinner } from "../../components/Spinner";
import useDecodeToken from "../../hooks/useDecodeToken";
import { userLogin } from "../../store/authSlice";

import "./style.css";

export const Login = () => {
  const { register, handleSubmit, reset } = useForm();
  const { loading, userInfo, error } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { decryptToken } = useDecodeToken();
  const userToken = useSelector((state) => state.auth.userToken);
  const user = decryptToken(userToken ? userToken : false);

  useEffect(() => {
    if (user) {
      // switch (user.roles[0]) {
      //   case "USER":
      //     return navigate("/teacher_profile", { replace: true });
      //   case "STUDENT":
      //     return navigate("/student_profile", { replace: true });
      //   default:
      //     return;
      // }
      return navigate("/", { replace: true });
    }
  }, [navigate, userInfo, user]);

  const onSubmit = (data) => {
    dispatch(userLogin(data));
    reset();
  };

  return (
    <AuthLayout>
      <div className="login-container">
        <div className="login-block">
          <h3 className="login-form_title">Вход в личный кабинет</h3>
          <form onSubmit={handleSubmit(onSubmit)} className="login-form">
            <input
              className="login-input"
              placeholder="Ваш логин"
              {...register("username")}
              required
            />
            <input
              type="password"
              className="login-input"
              placeholder="Ваш пароль"
              {...register("password")}
              required
            />
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? <Spinner type="circle" /> : "Войти"}
            </button>
          </form>
        </div>
        {error && <ErrorModal error="Неверный логин или пароль" />}
      </div>
    </AuthLayout>
  );
};
